import { GameConstants } from "../GameConstants";
import { TrophyState } from "./level-selection/TrophyState";

export class Confetti {

    public backgroundConfettiContainer: Phaser.Group;
    public foregroundConfettiContainer: Phaser.Group;

    private foregroundConfettiSpritesArray: Phaser.Sprite[];
    private backgroundConfettiSpritesArray: Phaser.Sprite[];
    private rndGenerator: Phaser.RandomDataGenerator;
    private activated: boolean;
    private frameCounter: number;
    private game: Phaser.Game;

    constructor(game: Phaser.Game) {

        this.game = game;

        this.backgroundConfettiContainer = new Phaser.Group(this.game);
        this.foregroundConfettiContainer = new Phaser.Group(this.game);

        this.frameCounter = 0;

        this.rndGenerator =  new Phaser.RandomDataGenerator([1, 2, 3]);

        this.backgroundConfettiSpritesArray = [];
        this.foregroundConfettiSpritesArray = [];

        // hacer 3 franjas de confetti
        // IZQUIERDA
        let confettiSprite: Phaser.Sprite = new Phaser.Sprite(this.game, 168, -1400, "texture_atlas_2");
        confettiSprite.animations.add("animation", Phaser.Animation.generateFrameNames("confetti_", 1, 6, "", 4), 8, true);
        confettiSprite.animations.play("animation");
        confettiSprite.anchor.set(.5);
        this.foregroundConfettiSpritesArray.push(confettiSprite);
        this.foregroundConfettiContainer.add(confettiSprite);

        confettiSprite = new Phaser.Sprite(this.game, 150, -1000, "texture_atlas_2");
        confettiSprite.angle = -90;
        confettiSprite.animations.add("animation", Phaser.Animation.generateFrameNames("confetti_", 1, 6, "", 4), 8, true);
        confettiSprite.animations.play("animation");
        confettiSprite.anchor.set(.5);
        this.foregroundConfettiSpritesArray.push(confettiSprite);
        this.foregroundConfettiContainer.add(confettiSprite);

        confettiSprite = new Phaser.Sprite(this.game, 150, -600, "texture_atlas_2");
        confettiSprite.angle = 90;
        confettiSprite.animations.add("animation", Phaser.Animation.generateFrameNames("confetti_", 1, 6, "", 4), 8, true);
        confettiSprite.animations.play("animation");
        confettiSprite.anchor.set(.5);
        this.foregroundConfettiSpritesArray.push(confettiSprite);
        this.foregroundConfettiContainer.add(confettiSprite);

        confettiSprite = new Phaser.Sprite(this.game, 150, -200, "texture_atlas_2");
        confettiSprite.angle = 90;
        confettiSprite.animations.add("animation", Phaser.Animation.generateFrameNames("confetti_", 1, 6, "", 4), 8, true);
        confettiSprite.animations.play("animation");
        confettiSprite.anchor.set(.5);
        this.foregroundConfettiSpritesArray.push(confettiSprite);
        this.foregroundConfettiContainer.add(confettiSprite);

        // DERECHA
        confettiSprite = new Phaser.Sprite(this.game, 550, -1400, "texture_atlas_2");
        confettiSprite.angle = 90;
        confettiSprite.animations.add("animation", Phaser.Animation.generateFrameNames("confetti_", 1, 6, "", 4), 8, true);
        confettiSprite.animations.play("animation");
        confettiSprite.anchor.set(.5);
        this.foregroundConfettiSpritesArray.push(confettiSprite);
        this.foregroundConfettiContainer.add(confettiSprite);

        confettiSprite = new Phaser.Sprite(this.game, 550, -1000, "texture_atlas_2");
        confettiSprite.angle = -90;
        confettiSprite.animations.add("animation", Phaser.Animation.generateFrameNames("confetti_", 1, 6, "", 4), 8, true);
        confettiSprite.animations.play("animation");
        confettiSprite.anchor.set(.5);
        this.foregroundConfettiSpritesArray.push(confettiSprite);
        this.foregroundConfettiContainer.add(confettiSprite);

        confettiSprite = new Phaser.Sprite(this.game, 568, -600, "texture_atlas_2");
        confettiSprite.angle = 180;
        confettiSprite.animations.add("animation", Phaser.Animation.generateFrameNames("confetti_", 1, 6, "", 4), 8, true);
        confettiSprite.animations.play("animation");
        confettiSprite.anchor.set(.5);
        this.foregroundConfettiSpritesArray.push(confettiSprite);
        this.foregroundConfettiContainer.add(confettiSprite);

        confettiSprite = new Phaser.Sprite(this.game, 550, -200, "texture_atlas_2");
        confettiSprite.angle = 180;
        confettiSprite.animations.add("animation", Phaser.Animation.generateFrameNames("confetti_", 1, 6, "", 4), 8, true);
        confettiSprite.animations.play("animation");
        confettiSprite.anchor.set(.5);
        this.foregroundConfettiSpritesArray.push(confettiSprite);
        this.foregroundConfettiContainer.add(confettiSprite);

        this.activated = false;
    }

    public update(): void {

        if (!this.activated) {
            return;
        }

        let i = 8;

        while (i--) {

            this.foregroundConfettiSpritesArray[i].x += 0.125;

            if (this.foregroundConfettiSpritesArray[i].x > 550) {
                this.foregroundConfettiSpritesArray[i].y += 3;
            } else {
                this.foregroundConfettiSpritesArray[i].y += 2.5;
            }

            if (this.foregroundConfettiSpritesArray[i].y > 1224) {

                if (this.foregroundConfettiSpritesArray[i].x > 550) {
                    this.foregroundConfettiSpritesArray[i].x = 550;
                } else {
                    this.foregroundConfettiSpritesArray[i].x = 150;
                }

                this.foregroundConfettiSpritesArray[i].y = -200;
            }
        }

        this.frameCounter ++;

        if (this.frameCounter % 60 === 0) {
            let confettiSprite: Phaser.Sprite = new Phaser.Sprite(this.game, this.rndGenerator.between(0, GameConstants.GAME_WIDTH), - 100, "texture_atlas_2");
            confettiSprite.angle = this.rndGenerator.between(0, 180);
            confettiSprite.animations.add("animation", Phaser.Animation.generateFrameNames("confetti_", 1, 6, "", 4), 6, true);
            confettiSprite.animations.play("animation");
            confettiSprite.anchor.set(.5);
            confettiSprite.scale.set(.5);
            this.backgroundConfettiSpritesArray.push(confettiSprite);
            this.backgroundConfettiContainer.add(confettiSprite);
        }

        i = this.backgroundConfettiSpritesArray.length;

        while (i--) {

            this.backgroundConfettiSpritesArray[i].x += .25;
            this.backgroundConfettiSpritesArray[i].y += 1.25;

            if (this.backgroundConfettiSpritesArray[i].y > 1124) {
                this.backgroundConfettiSpritesArray.splice(i, 1);
                this.backgroundConfettiContainer.remove(this.backgroundConfettiSpritesArray[i]);
            }
        }
    }

    public activate(time?: number): void {

        this.activated = true;

        if ( time !== null ) {
            this.game.time.events.add(time, this.removeConfetti, this);
        }
    }

    private removeConfetti(): void {

        this.game.add.tween(this.backgroundConfettiContainer).to({alpha: 0 }, 1000 , Phaser.Easing.Cubic.Out, true).
            onComplete.add(function(): void {
                this.backgroundConfettiContainer.destroy();
            }, this);

        this.game.add.tween(this.foregroundConfettiContainer).to({alpha: 0 }, 1000 , Phaser.Easing.Cubic.Out, true).
            onComplete.add(function(): void {
                this.foregroundConfettiContainer.destroy();
            }, this);

        TrophyState.currentInstance.confetti = null;
    }
}
